import __request__ from "routing/request";
export function node() {
  return __request__("GET", "/system/cluster/node", null, {}, {
    "Accept": ["application/json"]
  });
}
export function nodes() {
  return __request__("GET", "/system/cluster/nodes", null, {}, {
    "Accept": ["application/json"]
  });
}
export function nodesBypageAndper_pageAndqueryAndsortAndorder(sort = "hostname", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/system/cluster/nodes/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function nodeBynodeId(nodeId) {
  return __request__("GET", `/system/cluster/nodes/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
